/**
 * Import constants
 */
import { GET_BOUNCED_DATA_PENDING, GET_BOUNCED_DATA, GET_BOUNCED_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: {},
	error: null
};

/**
 * Bounced reducer
 * @param {*} state
 * @param {*} action
 */
export const bouncedReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_BOUNCED_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_BOUNCED_DATA:
			return {
				...state,
				loading: false,
				data: Object.assign({}, state.data, action.payload),
				error: null
			};
		case GET_BOUNCED_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
